---
title: Plan, extras et factures
parent: Documentation
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# Plan, extras, factures et pages légales

## Un seul plan avec tout inclus

TOBY propose un plan complet sans frais d'installation ni niveaux cachés :

- **Facturation mensuelle ou annuelle :** Choisissez une facturation mensuelle flexible (résiliable mensuellement à tout moment) ou une facturation annuelle avantageuse (également payable sur facture). Consultez la [liste des tarifs](/fr/pricing) pour les tarifs actuels.

Chaque abonnement inclut :

- **Votre propre domaine** (<DomainTlds />) — y compris le transfert d'un domaine existant (Domain-Umzug)
- **1 adresse e-mail** (info@...) avec une **boîte aux lettres de 15 GB (Maxi-Postfach)** et des adresses de redirection illimitées
- **Jusqu'à 15 pages** — créées et maintenues par chat, voix ou téléchargement de photo
- **1 langue supplémentaire** (2 langues au total) avec traduction automatique lors de la publication
- **Newsletter** avec **1 000 e-mails / mois**
- **Analyses de visiteurs** (respectueuses de la vie privée, sans bannières de cookies)
- **Pack de démarrage par courrier** (autocollant de porte et présentoir de table QR A5)
- **Hébergement dans l'UE** avec sécurité SSL automatique

## Extras optionnels

Si votre entreprise dépasse les limites incluses, vous pouvez ajouter des modules flexibles à tout moment dans **Réglages → Abonnement** (résiliables mensuellement, voir la [liste des tarifs](/fr/pricing)) :

- **+15 GB de stockage e-mail** (ou une boîte aux lettres supplémentaire)
- **+1 langue de site web supplémentaire**
- **+15 pages supplémentaires**
- **+5 000 e-mails de newsletter / mois**

## Obtenir une facture professionnelle appropriée (Site web vs. Google Play)

Si vous gérez une entreprise, un cabinet ou un compte de freelance et avez besoin d'une **facture professionnelle appropriée déductible des impôts (ordentliche Rechnung)** avec le nom de votre entreprise, l'adresse professionnelle et la TVA (MwSt.) affichés séparément, veuillez noter où vous vous abonnez :

- **Abonnement sur le site web (tobysite.com via Stripe) :** Vous recevez toujours une **facture professionnelle appropriée avec TVA** de notre part, adressée à votre entreprise. Vous pouvez télécharger toutes les factures antérieures et mettre à jour votre adresse de facturation professionnelle à tout moment dans **Réglages → Abonnement**.
- **Abonnement dans l'application Android (achat intégré Google Play) :** Lorsque vous vous abonnez via Google Play, Google traite le paiement en tant que marchand enregistré et émet uniquement un reçu de paiement Google Play standard. **Nous ne pouvons pas émettre de facture professionnelle avec TVA (ordentliche Rechnung) pour les abonnements facturés via Google Play.**

> **Conseil :** Vous pouvez vous abonner sur **tobysite.com** dans votre navigateur pour obtenir des factures professionnelles Stripe appropriées et continuer à utiliser les applications Android et iOS de TOBY avec votre compte sans frais supplémentaires.

## Ajouter vos mentions légales (Impressum) et votre politique de confidentialité (Datenschutz)

- **Votre propre texte juridique :** Étant donné que les exigences légales dépendent de votre structure d'entreprise, de votre profession et de votre pays, **TOBY ne génère pas de conseils juridiques et n'écrit pas de textes légaux (Impressum ou Datenschutzerklärung) par lui-même.**
- **Comment les ajouter :** Collez simplement votre texte de mentions légales ou de politique de confidentialité existant dans le chat (ou téléchargez-le en tant que document Word/PDF, ou demandez à TOBY de le copier depuis votre ancien site web) et dites *« Mettez ceci sur notre page de mentions légales. »* TOBY créera les pages et les liera proprement dans le pied de page de votre site web.
